import { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import Card from './Card';

export function Accordion({
  title,
  children,
  defaultOpen = false,
  className = ''
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Card padding="none" className={className}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-4 flex items-center justify-between hover:opacity-70 transition rounded-t-lg"
      >
        <h3 className="text-lg font-semibold text-text-primary-light dark:text-text-primary">
          {title}
        </h3>
        {isOpen ? (
          <ChevronUpIcon className="h-5 w-5 text-text-secondary-light dark:text-text-secondary" />
        ) : (
          <ChevronDownIcon className="h-5 w-5 text-text-secondary-light dark:text-text-secondary" />
        )}
      </button>
      {isOpen && (
        <div className="px-6 py-4 border-t border-border-light dark:border-border">
          {children}
        </div>
      )}
    </Card>
  );
}

export function AccordionGroup({ children, singleExpand = false, className = '' }) {
  return (
    <div className={`space-y-4 ${className}`}>
      {children}
    </div>
  );
}
